import React from 'react';
import PropTypes from 'prop-types';
import ReactPlayer from 'react-player';
import classnames from 'classnames';
import BrokenImageIcon from '@material-ui/icons/BrokenImage';

import { makeStyles } from '@material-ui/core/styles';
import { colors } from '../../constants/styleConstants';

const useStyles = makeStyles(() => ({
  root: {
    position: 'relative',
    backgroundColor: colors.background.gray,
  },
  playerWrapper: {
    width: '100%',
    height: '100%',
  },
  reactPlayer: {
    top: 0,
    left: 0,
  },
  playerWrapperThumb: {
    width: 168,
    minWidth: 168,
    height: 95,
    minHeight: 95,
  },
  hidePlayButton: {
    '& .react-player__play-icon': {
      display: 'none',
    },
    '& .react-player__shadow': {
      display: 'none !important',
    },
  },
  showPlayButton: {
    '& .react-player__play-icon': {
      display: 'flex',
      borderWidth: '10px 0px 10px 18px !important',
    },
    '& .react-player__shadow': {
      display: 'flex !important',
    },
  },
  limitSize: {
    maxWidth: '95vw',
    maxHeight: '95vh',
  },
  brokenVideo: {
    position: 'absolute',
    top: '50%',
    marginTop: '-12px',
    left: '50%',
    marginLeft: '-12px',
  },
}));

const MediaPlayer = ({ record, type, onThumbClick, showPlayButton, showControls, className, selfSize }) => {
  const classes = useStyles();
  const isThumb = type === 'thumb';
  const videoUrl = record.url || record?.file?.urls?.medium || record?.file?.urls?.original;

  return (
    <div
      className={classnames(
        classes.root,
        { [classes.limitSize]: selfSize },
        { [classes.playerWrapper]: !selfSize },
        className,
        {
          [classes.playerWrapperThumb]: isThumb,
          [classes.hidePlayButton]: isThumb,
          [classes.showPlayButton]: showPlayButton,
        },
      )}
    >
      {ReactPlayer.canPlay(videoUrl) ? (
        <ReactPlayer
          className={classnames(classes.reactPlayer, { [classes.thumbClass]: isThumb })}
          url={videoUrl}
          controls={showControls && !isThumb}
          onClick={() => onThumbClick(record)}
          light={isThumb || !showControls ? record?.thumbnail?.urls?.original : true}
          {...(selfSize ? {} : { width: '100%', height: '100%' })}
        />
      ) : (
        <BrokenImageIcon classes={{ root: classes.brokenVideo }} />
      )}
    </div>
  );
};

MediaPlayer.propTypes = {
  record: PropTypes.object,
  type: PropTypes.oneOf(['full', 'thumb']),
  onThumbClick: PropTypes.func,
  showPlayButton: PropTypes.bool,
};

MediaPlayer.defaultProps = {
  type: 'full',
  onThumbClick: () => {},
};

export default MediaPlayer;
